$(window).on('load', function() {
  'use strict';
  // リダイレクト処理
  var ua = (function(){
    var device = null,
        isMobile = false;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/iphone/i)) {
      device = 'iphone';
      isMobile = true;
    } else if (ua.match(/android/i)) {
      device = 'android';
      isMobile = true;
    } else {
      device = 'pc';
    }
    return {
      device: device,
      isMobile: isMobile
    }
  })();

  if (!ua.isMobile) {
    location.href = './comingsoon/pc.html';
    alert("PCでは遊べません。");
  }

  // モジュール読み込み
  const Game = require('./modules/game');
  const DataClass = require('./modules/data');
  // 初期化処理
  const game = new Game(new DataClass(),ua.isMobile);
});



// WEBPACK FOOTER //
// ./app/src/js/index.js